import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { StripeService, StripeCardComponent } from 'ngx-stripe';
import {
  StripeCardElementOptions,
  StripeElementsOptions
} from '@stripe/stripe-js';
import {environment} from '../../../../../../../environments/environment';
import {Actions, ApiEndpoints} from '../../../../../../shared/constants/ApiEndpoints';
import {GeneralConstant} from '../../../../../../shared/constants/GeneralConstant';
import {ResponseSnackbarService} from '../../../../../../shared/services/response-snackbar.service';
import {RequestMethod, RestService} from '../../../../../../shared/services/rest.service';
import {MessageInfo} from '../../../../../../shared/enums/error-messages/MessageInfo';
import {TooltipService} from '../../../../../../shared/services/tooltip.service';

@Component({
  selector: 'app-stripe-card-form-modal',
  templateUrl: './stripe-card-form-modal.component.html',
  styleUrls: ['../stripe-card-form.component.scss', '../stripe-utils.component.scss']
})
export class StripeCardFormModalComponent implements OnInit {
  @ViewChild(StripeCardComponent) card: StripeCardComponent;
  // elements: Elements;
//  cardNumber: StripeElement;
  // cardExpiry: StripeElement;
  // cardCvc: StripeElement;
  stripeForm: FormGroup;
  confirmBtnDisabled: boolean;
  defaultInvalid = MessageInfo.LIMIT_2_AND_100;
  defaultRequired = MessageInfo.REQUIRED_FIELD;
  defaultExists = MessageInfo.ALREADY_EXISTS;
  tooltipService: any;


  /*
  ** Options
   */
  options = {
    style: {
      base: {
        color: '#6d767e',
        fontWeight: 400,
        fontFamily: 'Roboto, sans-serif',
        lineHeight: '40px',
        fontSize: '14px',
        fontSmoothing: 'antialiased',
        '::placeholder': {
          color: '#adb5bd'
        }
      },
      invalid: {
        color: 'red'
      }
    },
  };

  /*
  * Element Options
   */
  elementsOptions: StripeElementsOptions  = {
    locale: 'en'
  };

  constructor(
    private restService: RestService,
    private fb: FormBuilder,
    private stripeService: StripeService,
    private snackBar: ResponseSnackbarService,
    public dialogRef: MatDialogRef<StripeCardFormModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit() {
    this.confirmBtnDisabled = false;
    this.initStripeForm();
    // this.initStripeElements();
  }

  onSubmit(): void {
    this.confirmBtnDisabled = true;
    const name = this.stripeForm.get('name').value;

    this.stripeService
      .createToken(this.card.element, {name})
      .subscribe(result => {
        this.onCreateToken(result);
      }, error => {
        this.confirmBtnDisabled = false;
      });
  }

  /*
  * Generate Token
   */
  onCreateToken(result): void {
    const URL = `${environment.api}/${environment.apiVersion}/${ApiEndpoints.ACCOUNT.PAYMENT}/${Actions.BASE_ACTIONS.UPDATE}/add_card`;

    if (result.token) {
      this.restService.restRequest(
        RequestMethod.POST,
        URL,
        {
          body: {
            token: result.token.id
          }
        }
      ).subscribe(response => {
        this.confirmBtnDisabled = false;

        // Close modal on success
        this.dialogRef.close({success: true});

        const message = response['message'];

        if (response && response['success']) {
          this.snackBar.onResponseMessage(message, GeneralConstant.SNACKBAR_RES_SUCCESS_CLASS);
        } else {
          this.snackBar.onResponseMessage(message, GeneralConstant.SNACKBAR_RES_ERROR_CLASS);
        }
      }, error => {
        const message = error.error.message;
        this.snackBar.onResponseMessage(message, GeneralConstant.SNACKBAR_RES_ERROR_CLASS);
      });
    } else if (result.error) {
      this.confirmBtnDisabled = false;
    }
  }

  /*
  * Init Stripe Form
   */
  private initStripeForm(): void {
    this.stripeForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(255), Validators.pattern(GeneralConstant.NAME_REGEX_VALIDATOR)]]
    });
    this.tooltipService = new TooltipService(this.stripeForm);
  }

  /*
  * Init Stripe Elements
   */
  // private initStripeElements(): void {
  //   this.stripeService.elements(this.elementsOptions)
  //     .subscribe(elements => {
  //       this.elements = elements;
  //
  //       if (!this.cardNumber) {
  //         this.cardNumber = this.elements.create('cardNumber', this.options);
  //         this.cardNumber.mount('#card-number');
  //       }
  //
  //       if (!this.cardExpiry) {
  //         this.cardExpiry = this.elements.create('cardExpiry', this.options);
  //         this.cardExpiry.mount('#card-expiry');
  //       }
  //
  //       if (!this.cardCvc) {
  //         this.cardCvc = this.elements.create('cardCvc', this.options);
  //         this.cardCvc.mount('#card-cvc');
  //       }
  //     });
  // }
}
